import type { AvatarUser } from '@core/account-ui';
import type { TellentMemberBrief } from '@core/ask-hr-types';

export const assigneeToAvatarUser = (assignee: TellentMemberBrief): AvatarUser => ({
  id: assignee.userGuid,
  firstName: assignee.firstName,
  lastName: assignee.lastName,
  initials:
    assignee.status === 'deactivated' ? '' : `${assignee.firstName[0]}${assignee.lastName[0]}`,
  hasAvatar: !!assignee.avatarThumbUrl,
  photoThumbUrl: assignee.avatarThumbUrl || '',
});
